export interface AccessLevel {
    acky_list: number[]
    acle_id: number
    acle_name: string
}
export interface ObjectToAccessLevelProps {
    acky_list: string
    acle_id: number | string
    acle_name: string
}
export function ObjectToAccessLevel(obj: ObjectToAccessLevelProps): AccessLevel {
    return {
        acky_list: typeof obj.acky_list == "string" ? obj.acky_list.split(",").map(value => parseInt(value)) : [],
        acle_id: typeof obj.acle_id == "string" ? parseInt(obj.acle_id) : obj.acle_id,
        acle_name: obj.acle_name,
    }
}